import Link from "next/link"
import { useTranslation } from "~/i18n"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"
import A from "~/components/UI/A"
import { IStyleElement } from "~/types/types"


const LabelNew: React.FC<IStyleElement> = (props) => {
  const [t] = useTranslation()
  return (
    <Link href='#'>
      <A style={{ textDecoration: 'none' }} {...props}>
        <Box style={{ borderRadius: 20, display: 'inline-block' }} bg='#ea2067' width='120px' height='30px' padding='5px 10px'>
          <Text centered color='#fff' size={12} style={{ textTransform: 'uppercase' }}>
            {t('SẢN PHẨM MỚI')}
          </Text>
        </Box>
      </A>
    </Link>
  )
}

export default LabelNew